/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IAzureBenefitApproveOrDeclineRequest } from "Interfaces/AzureBenefitRequests/IAzureBenefitApproveOrDeclineRequest";
import { IAzureBenefitApproveOrDeclineRequestDataResult } from "Interfaces/AzureBenefitRequests/IAzureBenefitApproveOrDeclineRequestDataResult";
import { IAzureBenefitRequestDetailsDataResult } from "Interfaces/AzureBenefitRequests/IAzureBenefitRequestDetailsDataResult";
import { IAzureBenefitRequestsDataResult } from "Interfaces/AzureBenefitRequests/IAzureBenefitRequestsDataResult";
import { IAzureBenefitRequestsRequest } from "Interfaces/AzureBenefitRequests/IAzureBenefitRequestsRequest";

import { MVP_AZURE_BENEFIT_BASE_URL, RD_AZURE_BENEFIT_BASE_URL } from "../Constants/SagaConstants";
import { IApiResult2 } from "../Interfaces/IApiResult";
import { get, post, put, IHttpResponse } from "./ApiUtils";

/**
 * Search all azure benefit requests for mvp.
 */
export async function searchMvpAzureBenefitRequests(
  searchRequest: IAzureBenefitRequestsRequest
): Promise<IHttpResponse<IApiResult2<IAzureBenefitRequestsDataResult>>> {
  const url = MVP_AZURE_BENEFIT_BASE_URL + "/search";
  return await post<IApiResult2<IAzureBenefitRequestsDataResult>>(url, searchRequest, true);
}

/**
 * Search all azure benefit requests for rd.
 */
export async function searchRdAzureBenefitRequests(
  searchRequest: IAzureBenefitRequestsRequest
): Promise<IHttpResponse<IApiResult2<IAzureBenefitRequestsDataResult>>> {
  const url = RD_AZURE_BENEFIT_BASE_URL + "/search";
  return await post<IApiResult2<IAzureBenefitRequestsDataResult>>(url, searchRequest, true);
}

/**
 * Get azure benefit request details for mvp.
 */
export async function getMvpAzureRequestDetails(
  userProfileId: number
): Promise<IHttpResponse<IApiResult2<IAzureBenefitRequestDetailsDataResult>>> {
  const url = MVP_AZURE_BENEFIT_BASE_URL + "/request/" + userProfileId;
  return await get<IApiResult2<IAzureBenefitRequestDetailsDataResult>>(url, true);
}

/**
 * Get azure benefit request details for an rd.
 */
export async function getRdAzureRequestDetails(
  userProfileId: number
): Promise<IHttpResponse<IApiResult2<IAzureBenefitRequestDetailsDataResult>>> {
  const url = RD_AZURE_BENEFIT_BASE_URL + "/request/" + userProfileId;
  return await get<IApiResult2<IAzureBenefitRequestDetailsDataResult>>(url, true);
}

/**
 * Approve or deny an azure benefit request for mvp.
 */
export async function approveOrDeclineMvpAzureBenefitRequest(
  approveOrDeclineRequest: IAzureBenefitApproveOrDeclineRequest
): Promise<IHttpResponse<IApiResult2<IAzureBenefitApproveOrDeclineRequestDataResult>>> {
  const url = MVP_AZURE_BENEFIT_BASE_URL + "/review";
  return await put<IApiResult2<IAzureBenefitApproveOrDeclineRequestDataResult>>(
    url,
    approveOrDeclineRequest,
    true
  );
}

/**
 * Approve or deny an azure benefit request for rd.
 */
export async function approveOrDeclineRdAzureBenefitRequest(
  approveOrDeclineRequest: IAzureBenefitApproveOrDeclineRequest
): Promise<IHttpResponse<IApiResult2<IAzureBenefitApproveOrDeclineRequestDataResult>>> {
  const url = RD_AZURE_BENEFIT_BASE_URL + "/review";
  return await put<IApiResult2<IAzureBenefitApproveOrDeclineRequestDataResult>>(
    url,
    approveOrDeclineRequest,
    true
  );
}
